import React from "react";
import { Row, Col } from "react-bootstrap";

export const ReportKpiCards = ({ totals, role }) => {
  if (!totals) return null;

  const cards = [
    {
      title: "TOTAL VOLUME",
      value: `₹${(totals.total_amount || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
      sub: `${totals.total_txn || 0} Total Txns`,
      bgColor: "#faf5ff",
      iconBg: "#f3e8ff",
      iconColor: "#7e57c2",
      iconClass: "ph-duotone ph-stack",
      barColor: "#e9d5ff"
    },
    {
      title: "SUCCESS AMOUNT",
      value: `₹${(totals.success_amount || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
      sub: `${totals.success_count || 0} Successful`,
      bgColor: "#f0fdf4",
      iconBg: "#dcfce7",
      iconColor: "#16a34a",
      iconClass: "ph-fill ph-check-circle",
      barColor: "#bbf7d0"
    },
    {
      title: role === "Main Admin" ? "PLATFORM EARNINGS" : "MY COMMISSION",
      value: `₹${(totals.commission || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`,
      sub: `TDS: ₹${totals.tds || 0} | Charges: ₹${totals.charge || 0}`,
      bgColor: "#f0f9ff",
      iconBg: "#e0e7ff",
      iconColor: "#2563eb",
      iconClass: "ph-bold ph-percent",
      barColor: "#c7d2fe"
    },
    {
      title: "FAILED / PENDING",
      value: `${totals.failed_count || 0} Failed`,
      sub: `${totals.pending_count || 0} In Progress`,
      bgColor: "#fff7ed",
      iconBg: "#ffedd5",
      iconColor: "#ea580c",
      iconClass: "ph-fill ph-warning-circle",
      barColor: "#fed7aa"
    },
  ];

  return (
    <Row className="g-2.5 mb-3">
      {cards.map((c, i) => (
        <Col xs={12} sm={6} lg={3} key={i}>
          <div
            className="card border-0 shadow-sm h-100 position-relative overflow-hidden"
            style={{
              borderRadius: "14px",
              backgroundColor: c.bgColor,
              transition: "transform 0.2s ease"
            }}
          >
            <div className="card-body p-2.5 px-3 position-relative z-1 d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center gap-2.5">
                <div
                  className="d-flex align-items-center justify-content-center flex-shrink-0"
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "50%",
                    backgroundColor: c.iconBg,
                    color: c.iconColor
                  }}
                >
                  <i className={c.iconClass} style={{ fontSize: "18px" }}></i>
                </div>
                <div>
                  <span className="d-block fw-bold mb-0 opacity-75" style={{ fontSize: "10px", color: "#64748b", letterSpacing: "0.3px" }}>
                    {c.title}
                  </span>
                  <h4 className="fw-extrabold mb-0" style={{ color: "#0f172a", fontSize: "16px" }}>
                    {c.value}
                  </h4>
                  <span className="d-block text-muted fw-medium" style={{ fontSize: "11px" }}>
                    {c.sub}
                  </span>
                </div>
              </div>

              {/* Mini Bar Chart Background Accent Graphic */}
              <div className="d-flex align-items-end gap-1 opacity-40 pe-1 ms-1" style={{ height: "26px" }}>
                <div style={{ width: "4px", height: "10px", backgroundColor: c.barColor, borderRadius: "2px" }}></div>
                <div style={{ width: "4px", height: "18px", backgroundColor: c.barColor, borderRadius: "2px" }}></div>
                <div style={{ width: "4px", height: "24px", backgroundColor: c.barColor, borderRadius: "2px" }}></div>
              </div>
            </div>
          </div>
        </Col>
      ))}
    </Row>
  );
};
